import type { ToastData } from '@/types/generated/App/Modules/Toast/Public/Data';
import { ToastKind } from '@/types/generated/App/Modules/Toast/Public/Enums';
import { showError, showInfo, showSuccess, showWarning } from '@/utils/toast';

/**
 * Renders one server toast. The title is the kind label; the message and the
 * optional description form the Sonner description, one per line.
 */
export function showToast(toastData: ToastData): void {
  const description = toastData.description === null
    ? toastData.message
    : `${toastData.message}\n${toastData.description}`;

  switch (toastData.kind) {
    case ToastKind.SUCCESS:
      return showSuccess('Success', description);
    case ToastKind.ERROR:
      return showError('Error', description);
    case ToastKind.INFO:
      return showInfo('Info', description);
    case ToastKind.WARNING:
      return showWarning('Warning', description);
    default: {
      const unhandledToast: never = toastData;
      throw new Error(`Unhandled toast kind: ${JSON.stringify(unhandledToast)}`);
    }
  }
}
